<template>
	<div>
		<div id="export-table" class="export-table">
			<div class="vx-row mb-2">
				<div class="vx-col w-full flex items-center justify-between">
					<div class="flex items-center">
						<feather-icon
							class="g-breadcrumb--title"
							icon="ChevronLeftIcon"
							svgClasses="h-8 w-8"
							@click.prevent="$emit('isShowFeatures', true)"
						/>
						<vs-breadcrumb
							class="g-breadcrumb--title"
							separator=""
							:items="[{title: $t('general.Return')}]"
							@click.prevent="$emit('isShowFeatures', true)"
						></vs-breadcrumb>
					</div>
					<div>
						<span class="g-table--title" v-text="$t('Alarm.AssignedZones')" style="color: #0b8ff4"></span>
					</div>
				</div>
			</div>
			<div class="vx-row pt-2">
				<div class="vx-col w-full flex justify-between">
					<p class="g-label--normal text-warning">{{ $t("general.SelectedZonesOnTheMap") }}</p>
					<p class="g-label--normal text-warning" :class="hasAnimation ? 'bounce-enter-active' : ''">
						{{ "(" + getZones.length + "/6)" }}
					</p>
				</div>
			</div>
			<vs-table
				:data="zoneList"
				v-model="selectedZones"
				multiple
				search
				pagination
				maxItems="7"
				@selected="handleSelected"
			>
				<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
					<vs-button
						v-if="selectedZones.length > 0"
						type="border"
						icon-pack="feather"
						@click.prevent="drawCartoPolygons"
					>
						<span class="g-table--title">
							{{ $t("Zonification.View") }}
						</span>
					</vs-button>
				</div>
				<template slot="thead">
					<vs-th class="g-table--title" v-text="'Id'"></vs-th>
					<vs-th class="g-table--title" v-text="$t('Name')"></vs-th>
				</template>
				<template slot-scope="{data}">
					<vs-tr
						:data="tr"
						:key="indextr"
						v-for="(tr, indextr) in data"
						:class="tr.disabled ? 'disabled' : ''"
					>
						<vs-td class="g-table--description">{{ tr.zone_id }}</vs-td>
						<vs-td class="g-table--description">{{ tr.name }}</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import {drawCartoPolygons} from "../../utils/plugins";

export default {
	components: {
		vSelect,
	},
	props: {
		zoneList: {
			type: Array,
			default: () => [],
			require: true,
		},
	},
	data() {
		return {
			selectedZones: [],
			hasAnimation: false,
		};
	},
	mounted() {
		const checkboxHeader = document.querySelector(".vs-table--thead .td-check .con-td-check .con-vs-checkbox");
		checkboxHeader.setAttribute("style", "display: none");
	},
	computed: {
		getZones() {
			return [...this.$store.state.moduleMap.zoneList];
		},
	},
	methods: {
		handleSelected(tr) {
			this.hasAnimation = !this.hasAnimation;
			const indexZone = this.getZones.indexOf(tr);
			if (indexZone !== -1) {
				const ItemIndex = this.getZones.findIndex(
					(zone) => zone.zone_id === tr.zone_id && zone.resource_id === tr.resource_id
				);
				this.getZones.splice(ItemIndex, 1);
			} else {
				this.$store.commit("moduleMap/SET_ZONE_GEOCERCA", tr);
			}
			if (this.selectedZones.length <= 5) {
				tr.checked = true;
				for (const item of this.zoneList) {
					item.disabled = false;
				}
			} else {
				for (const item of this.zoneList) {
					for (const itemSelected of this.selectedZones) {
						if (item.zone_id !== itemSelected.zone_id && !itemSelected.hasOwnProperty("checked")) {
							item.disabled = true;
						} else {
							itemSelected.disabled = false;
						}
					}
				}
			}
		},
		drawCartoPolygons() {
			if (this.getZones.length > 0 && this.getZones.length <= 6) {
				const cartodbIds = this.getZones.map(({zone_id}) => zone_id);
				drawCartoPolygons(cartodbIds.join(","));
				this.$store.dispatch("moduleMap/changeToggleMapSidebar", false);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Information"),
					text: this.$t("general.ZonesAllowedOnTheMap"),
					time: 6000,
				});
			}
		},
	},
};
</script>
<style lang="scss" scoped>
#export-table {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		tr.disabled {
			pointer-events: none;

			td {
				color: rgba(40, 40, 40, 0.3);
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap-reverse;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			padding: 0 1rem;

			td {
				font-style: normal;
				font-weight: 300;
				font-size: 12px;
				line-height: 15px;
				color: #666666;
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}

.bounce-enter-active {
	animation: bounce-in 0.5s;
	color: #ff9f43;
	font-weight: bold;
}

@keyframes bounce-in {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.5);
	}
	100% {
		transform: scale(1);
	}
}
</style>
